import { typedAxios, useReqParams } from './apiConfig';
import { VerifiedReportConfig } from '../hooks/useReportConfig';
import { isCourseType } from '../utils/trainings/typesChecking';
import { Api } from '../types/apiSpec';

export const useTeamMemberReport = () => {
  const reqParams = useReqParams({
    url: '/users/{userid}/training/report',
  });

  return (userid: string, config: VerifiedReportConfig) =>
    typedAxios({
      ...reqParams,
      method: 'post',
      params: { userid },
      body: config,
    });
};

export const useTrainingTeamMembersReport = ({ type, id }: { type: Api.TrainingType; id: string }) => {
  const reqParams = useReqParams({
    url: isCourseType(type)
      ? '/courses/{courseid}/teams/{teamid}/users/report'
      : '/learningpaths/{lpId}/teams/{teamid}/users/report',
  });

  return (teamid: string, reportConfig: VerifiedReportConfig) =>
    typedAxios({
      ...reqParams,
      method: 'post',
      params: { ...(isCourseType(type) ? { courseid: id } : { lpId: id }), teamid },
      body: reportConfig,
    });
};
